/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowElbowLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M237.65723,101.65723l-96,96a8.00181,8.00181,0,0,1-11.31446,0L60,127.31445,29.65723,157.65723A8.00066,8.00066,0,0,1,16,152V80a8.00039,8.00039,0,0,1,8-8H96a8.00066,8.00066,0,0,1,5.65723,13.65723l-30.343,30.343L136,180.68652l90.34277-90.34375a8.00053,8.00053,0,0,1,11.31446,11.31446Z" />
    </Svg>
  );
}

export default ArrowElbowLeft;
